<template>
  <v-text-field
    v-model="text"
    :clearable="clearable"
    dense
    :autofocus="focus"
    :hide-details="hideDetails"
    v-bind="$attrs"
    :outlined="outlined"
    :label="title"
    :error-messages="errorMessages"
    :loading="loading"
    :append-icon="appendIcon"
    :readonly="readonly"
    :data-test="dataTest"
    :class="dataTest"
    v-on="$listeners"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    hideDetails: {
      type: [Boolean, String],
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    errorMessages: {
      type: Array,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    appendIcon: {
      type: String,
      default: "",
    },
    focus: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    dataTest: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    text: "",
  }),
  computed: {
    title() {
      if (this.required) {
        return `${this.label}*`;
      } else {
        return this.label;
      }
    },
  },
  watch: {
    text(val) {
      this.$emit("input", val);
    },
    value: {
      handler(val) {
        this.text = val;
      },
      immediate: true,
    },
  },
};
</script>
<style>
.hide-details.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
.hide-details.v-text-field.v-text-field--enclosed.error--text
  .v-text-field__details {
  display: block;
}
</style>
